import React, { useState } from 'react';
import {
  formControlClass,
  formErrorBannerClass,
  formLabelClass,
  formPrimaryButtonClass,
  pageCanvasClass,
  surfaceCardClass,
} from '../components/ui/formUiClasses';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import apiClient from '../utils/apiClient';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError(t('auth.forgotPassword.emailRequired'));
      return;
    }

    setLoading(true);
    try {
      const response = await apiClient.post('/api/auth/forgot-password', { email: email.trim() });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || t('auth.forgotPassword.failed'));
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || t('auth.forgotPassword.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-full flex items-center justify-center bg-canvas py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-10 text-center text-3xl font-extrabold text-ink">
            {t('auth.forgotPassword.title')}
          </h2>
          <p className="mt-2 text-center text-sm text-ink-muted">
            {t('auth.forgotPassword.description')}
          </p>
        </div>

        {submitted ? (
          <div className="bg-surface p-8 rounded-lg shadow-md space-y-4">
            <p className="text-sm text-ink-muted" role="status">
              {t('auth.forgotPassword.successMessage')}
            </p>
            <Link
              to="/login"
              className="block text-center text-sm font-medium text-link hover:text-link-hover"
            >
              {t('auth.forgotPassword.backToLogin')}
            </Link>
          </div>
        ) : (
          <form className={`mt-8 space-y-6 p-8 shadow-md ${surfaceCardClass}`} onSubmit={handleSubmit} noValidate>
            <div>
              <label htmlFor="email" className={`${formLabelClass} mb-1`}>
                {t('common.email')}
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className={formControlClass}
                placeholder={t('common.enterEmail')}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError('');
                }}
              />
            </div>

            {error && (
              <div className={formErrorBannerClass} role="alert">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`w-full ${formPrimaryButtonClass}`}
            >
              {loading ? t('common.loading') : t('auth.forgotPassword.submit')}
            </button>

            <p className="text-center text-sm text-ink-subtle">
              <Link to="/login" className="font-medium text-link hover:text-link-hover">
                {t('auth.forgotPassword.backToLogin')}
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
